import request from '@/router/axios'
import env from '@/config/env'

/**
 * 查询支出/收款公司（供应商及其下属供应商）
 */
export const getAllLowMerchant = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/getAllLowMerchant',
    method: 'GET',
  })
}

/**
 * 根据支出公司获取车牌
 * @param spendingCompanyId
 */
export const getCar = (spendingCompanyId) => {
  return request({
    url: env.ferryUrl + `/settle-ticket-rule/car/${spendingCompanyId}`,
    method: 'GET',
  })
}

/**
* 获取线路名称
* @param id
*/
export const queryAllLowLine = (id) => {
  return request({
    url: env.ferryUrl + `/lineAdmin/getLineByMerchantIds?merchantId=${id}`,
    method: 'GET',
  })
}

/**
 * 获取车辆结算规则分页
 * @param settleCarRulePageDto
 */
export const settleCarRulePage = (settleCarRulePageDto) => {
  return request({
    url: env.ferryUrl + '/settle-car-rule/page',
    method: 'POST',
    data: settleCarRulePageDto
  })
}

/**
 * 新增、编辑票款结算规则
 * @param data
 */
export const saveCartSettle = (data) => {
  return request({
    url: env.ferryUrl + '/settle-car-rule/save-and-edit',
    method: 'POST',
    data: data
  })
}

/**
 * 获取票款规则结算规则详情
 * @param data
 */
export const settleCarDetails = (id) => {
  return request({
    url: env.ferryUrl + `/settle-car-rule/detail/${id}`,
    method: 'GET',
  })
}

/**
 * 删除票款结算规则
 * @param data
 */
 export const removeSettleCartRule = (data) => {
  return request({
      url: env.ferryUrl + '/settle-car-rule/delete',
      method: 'POST',
      data: data
  })
}

/**
 * 删除车辆结算单独配置规则
 * @param data
 */
 export const removeSettleCarRuleConfig = (data) => {
  return request({
      url: env.ferryUrl + '/settle-car-rule/delete-rule',
      method: 'POST',
      data: data
  })
}


/**
 * 摆渡结算规则-统一结算规则历史记录
 * @param data
 */
 export const historyDefault = (id) => {
  return request({
    url: env.ferryUrl + `/settle-car-rule/history-default/${id}`,
    method: 'GET',
  })
}
/**
 * 车辆结算规则-统一结算规则历史记录
 * @param data
 */
 export const historyCar = (id) => {
  return request({
    url: env.ferryUrl + `/settle-car-rule/history-car/${id}`,
    method: 'GET',
  })
}
/**
 * 车辆结算规则-特殊路线配置规则历史记录
 * @param data
 */
 export const historyLine = (id) => {
  return request({
    url: env.ferryUrl + `/settle-car-rule/history-line/${id}`,
    method: 'GET',
  })
}
